export enum OsmosisAssignmentPlayerQueryParams {
  assignmentId = 'assignmentId',
  syllabusItemId = 'syllabusItemId',
  catalogItemId = 'catalogItemId',
  osmosisVideoId = 'osmosisVideoId',
  osmosisVideoTitle = 'osmosisVideoTitle',
  osmosisVideoUrl = 'https://www.osmosis.org',
  ref = 'ref'
}

export enum OsmosisPilotStudySurvey {
  surveyLink = 'https://survey.alchemer.com/s3/7106604/Student-Osmosis-Pilot-Diary-Study-Survey',
  surveyLinkText = 'this 5-minute survey'
}
